import { createAppKit } from '@reown/appkit/react'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import type { AppKitNetwork } from '@reown/appkit/networks'
import { uni2Chain, bscChain } from './chains'

// Get project ID from environment
const projectId = import.meta.env.VITE_REOWN_PROJECT_ID || 'demo-project-id'

// App metadata
const metadata = {
  name: 'W2USDT Bridge',
  description: 'Bridge W2USDT (Uni2) to USDT (BSC)',
  url: typeof window !== 'undefined' ? window.location.origin : 'https://w2usdt.com',
  icons: [],
}

// Supported chains
const chains: [AppKitNetwork, ...AppKitNetwork[]] = [uni2Chain, bscChain]

// Create Wagmi adapter
export const wagmiAdapter = new WagmiAdapter({
  networks: chains,
  projectId,
})

// Create AppKit instance
createAppKit({
  adapters: [wagmiAdapter],
  networks: chains,
  defaultNetwork: uni2Chain,
  projectId,
  metadata,
  features: {
    analytics: false,
    email: false,
    socials: false,
  },
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': '#3b82f6',
    '--w3m-border-radius-master': '8px',
  },
})

export const wagmiConfig = wagmiAdapter.wagmiConfig
